var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"ma-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},_vm._l((this.model.rows),function(row){return _c('div',{key:row.id},[_vm._v("\n        "+_vm._s(row.full_name)+"\n      ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }